// @flow
import React, { type Element } from 'react';
import { Track } from 'angieslist-app-platform';
import type { Image, IndexedImage } from '../../../types';
import ThumbnailImageModal from './ThumbnailImageModal';

const styles = {
  imageFrame: {
    position: 'absolute',
    top: '10px',
    bottom: '10px',
    left: '10px',
    right: '10px',
    backgroundColor: 'white',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.30)',
    overflow: 'hidden',
  },
  hoverWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  backgroundImg: (url: string) => ({
    width: '100%',
    height: '100%',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 50%',
    backgroundImage: `url(${url})`,
  }),
  frameBottom: {
    position: 'absolute',
    borderBottom: '5px solid white',
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 15,
  },
  info: {
    color: 'white',
    height: 0,
    position: 'relative',
    zIndex: 10,
    padding: '0 5px',
  },
  title: {
    display: 'block',
    fontSize: '0.875em',
    fontWeight: 'bold',
    paddingTop: 12,
    margin: '0 15px 0 10px',
    lineHeight: '1.1em',
  },
  caption: {
    display: 'block',
    fontSize: '0.875em',
    margin: '12px 15px 0 10px',
    lineHeight: '1.285em',
  },
  hoverIcon: {
    zIndex: 11,
    position: 'absolute',
    color: 'white',
    fontSize: '1.25em',
    width: 35,
    height: 35,
    textAlign: 'center',
    right: 5,
    bottom: 5,
  },
};

type Props = {
  image: IndexedImage,
  images: Image[],
};

const ThumbnailImageComponent = ({
  image, images,
}: Props): Element<"div"> => {
  const { url, index } = image;
  return (
    <div className="gallery-image_col">
      <div style={styles.imageFrame}>
        <div style={styles.frameBottom} />
        <ThumbnailImageModal
          {...{
            images, index,
          }}
          title="Image Gallery"
        >
          <Track>
            <div
              id={`gallery-image-${index}`}
              style={styles.hoverWrapper}
              data-track-image-id={index}
              data-track-image-url={url}
            >
              <div style={styles.hoverIcon} className="gallery-image-hover-icon">
                <i className="icon icon-expand" />
              </div>
              <div style={{ padding: '5px', height: '100%' }}>
                <div style={styles.backgroundImg(url)} />
              </div>
            </div>
          </Track>
        </ThumbnailImageModal>
      </div>
    </div>
  );
};

export default ThumbnailImageComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/ThumbnailImage.js